import React, {useEffect} from "react";
import "./SlideShow.css"
import {Input} from "@rebass/forms";

import { useField } from "formik";
import {LoadingIcon} from "./Icons/LoadingIcon";


// TODO create loading animation and cancel pending updateSlide requests upon button press
export class SlideShow extends React.Component<any, any>{
  private input_ref = React.createRef<HTMLInputElement>();
  private slide_show_ref = React.createRef<HTMLDivElement>();
  private scroll_cache: number;
  private lock_scroll: boolean;
  private loading: boolean;

  constructor(props) {
    super(props);

    this.state = {
      slide_number: props.init_slide_number,
    }

    this.loading = true

    this.scroll_cache = 0
    this.lock_scroll = false
  }

  render() {
    if (this.props.slides.length === 0) {
      return <LoadingIcon/>
    }

    const previous_slide = this.props.slides[this.state.slide_number - 2]
    const next_slide = this.props.slides[this.state.slide_number]

    return (
      <div style={{position: "relative"}}>
        <div className="vvp_results-index" style={{position: "absolute", zIndex: 10, right:0, top:0}}>
          <input
            type="text"
            style={{width: "30px"}}
            defaultValue={this.state.slide_number}
            ref={this.input_ref}
            //onBeforeInput={(e) => {e.target["value"]=""; console.log(e)}}
            onFocus={(e) => e.target["value"]=""}
            onBlur={(e) => this.updateSlide(parseInt(e.target["value"]))}
            onKeyDown={(e) => { // @ts-ignore
              if (e.code === "Enter") e.target.blur()
            }}
          />
          {" / " + this.props.slides.length}
        </div>
        <div className="vvp_results-fade">
          <div className="vvp_results-previous" onClick={() => this.updateSlide(this.state.slide_number - 1)}>
            {previous_slide}
            <div>
              {previous_slide === undefined? undefined:
                <img className="svg_button" src="/ui/next.svg" alt="prevvious bundle"
                     style={{
                       position: "absolute",
                       height: "100px",
                       left: "10%",
                       bottom: "38.5%",
                       opacity: 0.5,
                       zIndex: 1,
                       transform: "scaleX(-1)"
                     }}
                     onMouseEnter={(e) => e["target"]["style"]["opacity"] = 1}
                     onMouseLeave={(e) => e["target"]["style"]["opacity"] = 0.5}
                />
              }
            </div>
          </div>
          <div className="vvp_results-wrapper" onClick={() => this.props.onSlideClick(this.state.slide_number)} ref={this.slide_show_ref} onMouseEnter={() => this.onMouseEnter()} onMouseLeave={() => this.onMouseLeave()}>
            {this.props.slides[this.state.slide_number - 1]}
          </div>
          <div className="vvp_results-next" onClick={() => this.updateSlide(this.state.slide_number + 1)}>
            {next_slide}
            <div>
              {next_slide === undefined? undefined:
                <img className="svg_button" src="/ui/next.svg" alt="next bundle"
                     style={{
                       position: "absolute",
                       height: "100px",
                       right: "10%",
                       bottom: "38.5%",
                       opacity: 0.5,
                       zIndex: 1
                     }}
                     onMouseEnter={(e) => e["target"]["style"]["opacity"] = 1}
                     onMouseLeave={(e) => e["target"]["style"]["opacity"] = 0.5}
                />
              }
            </div>


          </div>
        </div>
      </div>
    )
  }

  updateSlide(slide_number) {
    this.setState((state) => {
      if (isNaN(slide_number) || state.slide_number === slide_number || slide_number > this.props.slides.length || slide_number <= 0) {
        this.updateInput(state.slide_number)
        return
      }

      if (this.props.passSlideNumber) this.props.passSlideNumber(slide_number)

      this.updateInput(slide_number)
      return {slide_number: slide_number}
    })
  }

  updateInput(slide_number) {
    const target: any = this.input_ref.current
    target.value = slide_number.toString()
    target.style.width = 10 * (target.value.length + 1) + "px"
  }

  handleScroll(e) {
    if (typeof e.wheelDelta !== "number" || isNaN(e.wheelDelta)) return
    if (isNaN(this.scroll_cache)) this.scroll_cache = 0
    this.scroll_cache += e.wheelDelta

    if (Math.abs(this.scroll_cache) >= 80) {
      this.updateSlide(this.state.slide_number - this.scroll_cache/Math.abs(this.scroll_cache))
      this.scroll_cache = 0
    }
  }

  onMouseEnter() {
    // @ts-ignore
    document.getElementById("PatientsOverview").style.overflow = "hidden"
  }

  onMouseLeave() {
    // @ts-ignore
    document.getElementById("PatientsOverview").style.overflow = "auto"
  }

  componentDidUpdate() {
    if (this.loading && this.slide_show_ref.current !== null) {
      let slides_show: Element| any = this.slide_show_ref.current

      if (slides_show.addEventListener) {
        // IE9, Chrome, Safari, Opera
        slides_show.addEventListener("mousewheel", e => this.handleScroll(e), false);
        // Firefox
        slides_show.addEventListener("DOMMouseScroll", e => this.handleScroll(e), false);
        // IE 6~8
      } else slides_show.attachEvent("onmousewheel", e => this.handleScroll(e));

      this.updateSlide(this.props.init_slide_number)

      this.loading = false
    }

  }
}

